import React from "react";
import * as uuid from 'uuid';
import { Button } from "../../../../components/Button";
import { Icon } from "../../../../components/core/Icon";
import { Steps } from "../../../../components/Steps";
import { ProductNameAndImageStep } from "./Steps/ProductNameAndImageStep";
import { ProductDrinkSizes } from "./Steps/ProductDrinkSizes";

import styles from "../../../../../styles/add-product.module.scss";
import { ProductAvailabilityStep } from "./Steps/ProductAvailabilityStep";
import { ProductTagsStep } from "./Steps/ProductTagsStep";
import { Availability } from "../../../../utils/Availability";


const StepNames = {
    NAME_AND_IMAGE: 'NAME_AND_IMAGE',
    SIZES: 'SIZES',
    TAGS: 'TAGS',
    AVAILABILITY: 'AVAILABILITY'
}

const StepIndexes = {
    NAME_AND_IMAGE: 1,
    SIZES: 2,
    TAGS: 3,
    AVAILABILITY: 4
}

export class ProductPizza extends React.Component {

    state = {
        product: {
            type: 'flavor',
            name: null,
            show: true,
            highlight: false,
            availability: null,
            extra_ingredients: [],
            items: [],
            sizes: [],
        },
        steps: 4,
        step: StepNames.NAME_AND_IMAGE,
        currentStep: StepIndexes.NAME_AND_IMAGE,
        disabled: true
    }

    componentDidMount() {
        const { product: stateProduct } = this.state;
        const { product, category } = this.props;

        const defaultSizes = [
            ...category.sizes.map(({ id, parent, ...size }) => ({ ...size }))
        ];

        if(category.sizes.length == 0) {
            defaultSizes.push({ name: "Tamanho Único", type: 'size', ref_id: uuid.v4(), price: 0 })
        }

        this.setState({
            product: {
                ...stateProduct,
                ...product,
                sizes: defaultSizes,
                parent: category.id
            }
        });
    }

    onChangeProduct(values) {
        const { product } = this.state;
        this.setState({ product: { ...product, ...values } }, this.validateStep.bind(this));
    }

    validateStep() {
        const { step, product } = this.state;
        switch (step) {
            case StepNames.NAME_AND_IMAGE:
                return this.setState({ disabled: !product || !product.name });
            case StepNames.SIZES:
                return this.setState({
                    disabled: product.sizes.reduce((f, size) => (f || (!size.price && size.price !== 0)), false)
                })
            case StepNames.TAGS:
                return this.setState({
                    disabled: false
                });
            case StepNames.AVAILABILITY:
                return this.setState({
					disabled: Availability.hasIncompleteAvailability(product.availability)
                });
            default:
                return null;
        }
    }

    nextStep() {
        const { step } = this.state;

        switch (step) {
            case StepNames.NAME_AND_IMAGE:
                return this.setState({
                    step: StepNames.SIZES,
                    currentStep: StepIndexes.SIZES,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.TAGS,
                    currentStep: StepIndexes.TAGS,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.TAGS:
                return this.setState({
                    step: StepNames.AVAILABILITY,
                    currentStep: StepIndexes.AVAILABILITY,
                    disabled: true
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return false;
            default:
                return null;
        }
    }

    prevStep() {
        const { step } = this.state;

        switch (step) {
            case StepNames.SIZES:
                return this.setState({
                    step: StepNames.NAME_AND_IMAGE,
                    currentStep: StepIndexes.NAME_AND_IMAGE,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.TAGS:
                return this.setState({
                    step: StepNames.SIZES,
                    currentStep: StepIndexes.SIZES,
                    disabled: false
                }, this.validateStep.bind(this));
            case StepNames.AVAILABILITY:
                return this.setState({
                    step: StepNames.TAGS,
                    currentStep: StepIndexes.TAGS,
                    disabled: false
                }, this.validateStep.bind(this));
            default:
                return null;

        }
    }

    onSave () {
        const { onSave } = this.props;
        const { product } = this.state;

        product.availability = Availability.getValidAvailability(product.availability);

        onSave && onSave(product);
    }

    render() {
        const { category } = this.props;
        const { product, currentStep, step, steps, disabled } = this.state;

        return (
            <>
                <Steps steps={steps} currentStep={currentStep} />
                <div className={styles.scrollContainer}>
                    {step === StepNames.NAME_AND_IMAGE && (<ProductNameAndImageStep product={product} onChange={this.onChangeProduct.bind(this)} />)}
                    {step === StepNames.SIZES && (<ProductDrinkSizes category={category} product={product} onChange={this.onChangeProduct.bind(this)} />)}
                    {step === StepNames.TAGS && (<ProductTagsStep item={product} onChange={this.onChangeProduct.bind(this)} />)}
                    {step === StepNames.AVAILABILITY && (<ProductAvailabilityStep item={product} onChange={this.onChangeProduct.bind(this)} />)}
                </div>
                <div className={`${styles.footer} ${step !== StepNames.NAME_AND_IMAGE ? "justify-between" : "justify-end"}`}>
                    {step !== StepNames.NAME_AND_IMAGE && (
                        <Button design="default-icon" onClick={this.prevStep.bind(this)}>
                            <Icon name="long-arrow-left" size="xl" />
                        </Button>
                    )}
                    {step === StepNames.AVAILABILITY ? (
                        <Button design="primary-icon" onClick={this.onSave.bind(this)} disabled={disabled}>
                            <Icon name="check" size="xl" />
                        </Button>
                    ) : (
                        <Button design="primary-icon" onClick={this.nextStep.bind(this)} disabled={disabled}>
                            <Icon name="long-arrow-right" size="xl" />
                        </Button>
                    )}
                </div>
            </>
        );
    }
}